// token.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { UserService } from './user.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);
  const isBrowser = isPlatformBrowser(platformId);
  const router = inject(Router);
  const userService = inject(UserService);
  const spinner = inject(NgxSpinnerService);

  if (isBrowser && !req.headers.has('X-Skip-Interceptor')) {
    spinner.show();
  }

  const authToken = userService.getToken();
  let setHeaders:any = { 
	  Accept: 'application/json' 
  };

  if (isBrowser && authToken) {
    setHeaders = { ...setHeaders, Authorization: `Bearer ${authToken}` };
  }

  return next(req.clone({ setHeaders })).pipe(
    catchError((error: any) => {
      let message = null;

      if (error.status === 0) {
        message = 'Invalid request';
      } else if (error.status === 401) {
        message = 'Unauthorized!';
        userService.logout();
        userService.setAuthLogoutListener();

        if (!req.headers.has('X-Skip-Redirect')) {
          router.navigate(['/login']);
        }
      } else if (error.status === 500) {
        message = 'Something went wrong. Please try again!';
      }

      if (isBrowser && message && !req.headers.has('X-Skip-Response')) {
        userService.errorMessage(message);
      }

      return of(error);
    }),
    finalize(() => {
      if (isBrowser) {
        spinner.hide();
      }
    })
  );
};
